import { Component, OnInit } from '@angular/core';
import {NavParams, ModalController } from '@ionic/angular';
import { SingleNew } from 'src/app/interfaces/news.intereface';
import { AuthService } from 'src/app/services/auth.service';
import { ToolsService } from 'src/app/services/tools.service';
import { AnalyticsService } from 'src/app/services/analytics.service';

@Component({
  selector: 'app-news-detail',
  templateUrl: './news-detail.page.html',
  styleUrls: ['./news-detail.page.scss'],
})
export class NewsDetailPage implements OnInit {

  public validVideoUrl: string;
  private currentNewId: any;
  public singleNew: SingleNew;
  
  constructor(
    public navParams: NavParams,
    public modalController: ModalController,
    public toolsService: ToolsService,
    public authService: AuthService, 
    private analyticsService: AnalyticsService
  ) {
    this.analyticsService.AnalyticsPageView('news-detail');
    this.currentNewId = this.navParams.data.news.id;
  }

  ngOnInit() {
    this.loadNew();
  }

  async loadNew() {
    await this.toolsService.showLoader();
    if(typeof this.currentNewId != 'number') {
      await this.toolsService.dismissLoader();
      return;
    }
    let response = await this.authService.getNews(this.currentNewId);
    this.singleNew = response as SingleNew;
    // Extract video URL from iframe in content
    const regex = /<iframe.+?src="(.+?)".*?><\/iframe>/gi;
    const match = regex.exec(this.singleNew.content);
    const videoUrl = match ? match[1] : null;

    // Validate video URL
    // If any other platform is needed, just add it to the regex
    let isValidVideoUrl = false;
    if (videoUrl) {
      const videoRegex = /^(https?:\/\/)?((www\.)?youtube\.com|youtu\.be|player\.vimeo\.com|www\.dailymotion\.com)\/.+$/i;
      isValidVideoUrl = videoRegex.test(videoUrl);
    }

    // Set valid video URL in component state
    this.validVideoUrl = isValidVideoUrl ? videoUrl : null;
    await this.toolsService.dismissLoader();
  }

  closeModal() {
    this.modalController.dismiss();
  }

}
